import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface FramingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Framing: React.FC<FramingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [framing, set_framing] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Framing']?.['Framing'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Framing': { ...b.values?.['Framing'], 'Framing': v } } })
    );
    const label = 'Framing (including roof)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(framing)}
                />
            ) : (
                <MoneyBox
                    id={'framing'}
                    allowNegative={false}
                    value={framing}
                    onChange={(value) => set_framing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
